import { FunctionComponent, useState } from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import ButtonProgress from '../../eliot-components/src/ButtonProgress/ButtonProgress';
import { useConfig } from '../../eliot-components/src/ConfigProvider/hooks';
import { useUpdateUserMutation } from '../../store/api-slice';
import { useSnackbar } from 'notistack';

export interface Props {
  readonly userID: string;
}

const GlobalNoRolesPage: FunctionComponent<Props> = ({ userID }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { apiBaseURL } = useConfig();
  const [updateUser] = useUpdateUserMutation();
  const { enqueueSnackbar } = useSnackbar();

  // if we don't pass in a userID, do a logout
  if (!userID) {
    window.location.href = '/logout';
    return null;
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ padding: '15px' }}
    >
      <Paper
        variant="outlined"
        style={{
          textAlign: 'center',
          height: '90vh',
          minHeight: '350px',
          width: '100%',
          padding: '24px',
        }}
      >
        <Warning color="primary" style={{ marginTop: '24px' }} />
        <Typography variant="h5">
          You do not have access to any organizations
        </Typography>
        <br />
        <ButtonProgress
          variant="contained"
          color="primary"
          size="large"
          isLoading={isLoading}
          onClick={() => {
            setIsLoading(true);
            updateUser({
              data: { globalRolesModeEnabled: true },
              apiBaseURL,
              id: userID,
            })
              .then((res: any) => {
                if (res.error) {
                  setIsLoading(false);
                  enqueueSnackbar(res.error.message, { variant: 'error' });
                  return;
                }
                window.location.href = '/';
              })
              .catch((err) => {
                setIsLoading(false);
                enqueueSnackbar(err.message, { variant: 'error' });
              });
          }}
        >
          Enable Global Mode
        </ButtonProgress>
      </Paper>
    </Grid>
  );
};

export default GlobalNoRolesPage;
